export default __webpack_public_path__ + "static/media/healthscan-login-illustration.929fc74c.svg";